import { createContext, useContext } from "react";
import { assert } from "utils";

import { type StatisticsRepository } from "src/repositories/statistics/StatisticsRepository";
export const StatisticsRepositoryContext =
  createContext<StatisticsRepository | null>(null);
export function useStatisticsRepository() {
  const repository = useContext(StatisticsRepositoryContext);
  assert(repository, "StatisticsRepositoryContext is missing");
  return repository;
}
